export const APP_TITLE = 'OpenGolfSim';
export const TERMS_URL = 'https://help.opengolfsim.com/terms';
export const HELP_URL = 'https://help.opengolfsim.com';
export const CONTACT_URL = 'https://help.opengolfsim.com/contact';
export const DISCORD_LINK = 'https://help.opengolfsim.com/connect-with-us/';

export const IOS_APP_STORE = 'https://apps.apple.com/us/app/opengolfsim/id6745538399';
export const GOOGLE_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.ogs.opengolfsim';


export const SUBSCRIPTION_PRODUCT = 'pro_annual';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
